import { userKeys } from './keys/user';
import { analysisKeys } from '@/hooks/constants/keys/analysis';
import { blackdayKeys } from '@/hooks/constants/keys/blackday';
import { diffKeys } from '@/hooks/constants/keys/diff';
import { domainKeys } from '@/hooks/constants/keys/domain';
import { experimentKeys } from '@/hooks/constants/keys/experiment';
import { productEntityKeys } from '@/hooks/constants/keys/product-entity';
import { serviceOnboardingKeys } from '@/hooks/constants/keys/service-onboarding';
import { techFamiliesKeys } from '@/hooks/constants/keys/tech-families';
import { tenantSyncKeys } from '@/hooks/constants/keys/tenant-sync';
import { variableKeys } from '@/hooks/constants/keys/variable';
import { variableComplexityPolicyKeys } from '@/hooks/constants/keys/variable-complexity-policy';

// import { variableKeys } from '@/hooks/constants/variable-key';

export const queryKeys = {
  planner: {
    // ...variableKeys.planner,
    ...diffKeys.planner,
    ...experimentKeys.planner,
    ...blackdayKeys.planner,
    ...variableKeys.planner,
    ...productEntityKeys.planner,
    ...domainKeys.planner,
    ...userKeys.planner,
    ...analysisKeys.planner,
    ...variableComplexityPolicyKeys.planner,
    ...serviceOnboardingKeys.planner,
    ...techFamiliesKeys.planner,
    tenantSyncPreview: tenantSyncKeys.planner.syncPreview,
  },
};
